export function parseQueryStringKeyValues(t) {
  null == t && (t = "");
  var r = t.split("?").slice(1).join("?"),
      n = {};

  if (null != r) {
    var _t = r.split("&");

    for (var _r = 0; _r < _t.length; _r++) {
      var a = _t[_r].split("=");

      "" !== a[0] && (n[a[0]] = a[1]);
    }
  }

  return n;
}
export function isURIJavascriptOrData(t) {
  return !(!t || 0 !== (t = t.toString().toLowerCase()).lastIndexOf("javascript:", 0) && 0 !== t.lastIndexOf("data:", 0));
}